import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { GlobalContext } from '../../../App';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { v4 as uuidv4 } from 'uuid';
import { addRecordToCache, createFetchDataServer, createFetchDataServerWithCallback, getTableData } from '../../../database/fetchData';
import CommponentOptions from './data/commponentOptions';

const NAME_ENTITY = 'גוש';

function BlockCreate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormBlocks.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataBlock, getEntitiesByAttr } = useQueries();

  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת גוש`);
  }, [location.pathname]);
  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      if (value?.unicId) {
        lock = field.name === 'cemeteryId';
      }
      return {
        ...field,
        disabled: lock ? lock : field.disabled,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (value?.unicId) {
      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce((acc, field) => {
          return {
            ...acc
          };
        }, {});

      let res = fieldAuto(value, initialFormValues);
      initialFormValues = res;

      if (Object.keys(formValues).length === 0) {
        setFormValues(initialFormValues); // newValues הם הערכים החדשים שברצונך לעדכן
      }
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data, newFormValues) => {
    setCemeteries(context?.contextCemeteries?.map((cemetery) => CommponentOptions({ value: cemetery?.unicId, label: cemetery?.cemeteryNameHe })));
    setBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', data?.unicId));
    return { ...newFormValues, cemeteryId: data?.unicId };
  };

  useEffect(() => {
    if (!loading) {
      handleAllDataLoaded();
    }
  }, [loading, context?.contextCemeteries, context?.contextBlocks]);

  // --------------

  const fieldChangeCemeteryId = async (event) => {
    if (event.target.value !== '') {
      const blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value);
      setBlocks(blocks);
    } else {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        if (dataBlocks) {
          const tempBlocks = dataBlocks?.value;

          setBlocks(tempBlocks); // שמירת המידע ב-state
        }
      }
    }
  };
  const handleChange = (event) => {
    let newFormValues = formValues;
    if (event.target.name === 'cemeteryId') {
      fieldChangeCemeteryId(event);
    }
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  };
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (blocks.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      let updatedFormValues = { ...formValues };

      setLoadingData(true);

      const unicId = uuidv4();

      // שליחה לשרת עם הערך החדש
      let res = await addOrUpdateDataBlock(formValues, unicId);
      if (res === 200) {
        context?.setContextBlocks((prev) => {
          const tempCemetery = context?.contextCemeteries.find((c) => c.unicId === formValues.cemeteryId);
          updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId, cemeteryNameHe: tempCemetery?.cemeteryNameHe, cemeteryNameEn: tempCemetery?.cemeteryNameEn, availableSum: 0, purchasedSum: 0, buriedSum: 0, savedSum: 0, graveSum: 0 };

          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          addRecordToCache(updatedFormValues, 'dataBlocks');

          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, updatedFormValues];
          }
        });
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        if (dataCemeteries && dataBlocks) {
          setLoading(false);
        }
      } else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['cemeteries'], token, handlePartialUpdate);

        fetchDataServer(['blocks'], token);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate title={`הוספת ${NAME_ENTITY}`} btn={`שמור`} fields={fieldsWithDynamicDisabled} columns={columns} formValues={formValues} handleChange={handleChange} handleSubmit={handleSubmit} errors={errors} options={{ cemeteryId: cemeteries }} />
    </>
  );
}

export default BlockCreate;
